export interface PageViewConsentEvent {
  event: string;
}
export interface PageViewEvent {
  event: string;
  context: PageViewEventContext;
}

export interface PageViewEventContext {
  locale: PageViewEventLocale;
  page: PageViewEventData;
  product?: PageViewEventProduct;
  checkout?: PageViewEventCheckout;
  user?: PageViewEventUser;
}

export interface PageViewEventLocale {
  country: string;
  language: string;
}

export interface PageViewEventData {
  type: string;
  name: string;
}

export interface PageViewEventProduct {
  item_category: string;
  item_category2: string;
  item_id: string;
  item_name: string;
  quantity?: string;
  price: string;
  currency: string;
  pricing_unit: number;
  is_accessory: boolean;
}

export interface PageViewEventCheckout {
  step: number;
}

export interface PageViewEventUser {
  user_id: string | undefined;
  is_logged_in: boolean;
}

export enum TrackingFormSubmitStatus {
  SUCCESS = 'success',
  FAIL = 'fail',
}
export enum TrackingFormType {
  CONTACT = 'contact',
  CREDIT_ACCOUNT_APPLICATION = 'credit account application',
  QUOTATION = 'quotation_form',
}
